<template>
  <v-container>
    <h1>New Diary Entry</h1>
    <v-form>
      <v-alert
        v-model="isError"
        dismissible
        type="error"
        transition="fade-transition"
      >
        {{ errMessage }}
      </v-alert>

      <v-text-field
        v-model="title"
        label="Title"
        :error-messages="errors.title"
        id="title"
        @focus="inputFocus"
      />

      <v-textarea
        v-model="body"
        label="Body"
        :error-messages="errors.body"
        id="body"
        @focus="inputFocus"
      />

      <v-btn
        @click="submit"
      >Add</v-btn>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    title: null,
    body: null,

    isError: false,
    errMessage: null,
    errors: {
      title: null,
      body: null
    }
  }),
  methods: {
    submit: function (ev) {
      var _this = this

      this.axios.post('/diaries', {
        title: this.title,
        body: this.body
      })
        .then(function (res) {
          _this.$router.push('/diary')
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  }
}
</script>
